export default "__VITE_ASSET__DWHN1UaN__"